import React from "react";
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';

import PercentFormatter from "../../../../../utils/percent_formatter.js";

const blockStyles = makeStyles(theme => ({
  legend: {
    display: "none",
    marginTop: "18px",
    paddingLeft: "0px",
    ['@media (max-width: 768px)']: {
      display: "block"
    },
  },
  legendRow: {
    display: "flex",
    fontSize: "10px",
    fontWeight: theme.typography.fontWeightRegular,
    alignItems: "center",
    margin: "0px !important"
  },
  color: {
    flexBasis: "10px",
    flexShrink: 0,
    height: "10px",
    marginRight: "15px",
  },
  text: {

  }

}));

const Legend = props => {
  const classes = blockStyles();
  const { columns, className } = props;

  return (
    <ul className = { clsx(classes.legend, className) } > 
      {
        columns.map((column) => {
          const { percentValue, color, key, name } = column;
          return <li className = { classes.legendRow }
                     key = { key }>
            <div className = { classes.color } 
                 style = { {
                   backgroundColor: color
                 } }/>
            <div className = { classes.text } >
              { `${name} ${PercentFormatter.format(percentValue / 100)}` }
            </div>
          </li>
        })
      }
    </ul>
  );
}

export default Legend;